import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { getInvitation } from '../api/auth';
import { acceptInviteAsync, clearError } from '../store/authSlice';
import BrandLogo from '../mobile/BrandLogo';

// La pagina del link di invito, e di reimpostazione della password.
//
// L'email non si sceglie qui: la decide l'invito. Se chi riceve il link
// potesse cambiarla, un link inoltrato creerebbe un account con un indirizzo
// qualunque.
export default function AcceptInvitePage() {
  const { token } = useParams();
  const dispatch = useDispatch();
  const { isAuthenticated, loading, error, user } = useSelector(state => state.auth);
  const [fatto, setFatto] = useState(false);
  const [invito, setInvito] = useState(null);
  const [problema, setProblema] = useState('');
  const [password, setPassword] = useState('');
  const [conferma, setConferma] = useState('');

  useEffect(() => { dispatch(clearError()); }, [dispatch]);
  useEffect(() => {
    let attivo = true;
    getInvitation(token)
      .then(({ data }) => { if (attivo) setInvito(data); })
      .catch(e => { if (attivo) setProblema(e.response?.data?.detail || 'Il link non è valido o è scaduto.'); });
    return () => { attivo = false; };
  }, [token]);

  if (fatto) return <Navigate to="/" replace />;

  const reimposta = invito?.kind === 'reset';
  const diverse = conferma.length > 0 && password !== conferma;
  const invia = event => {
    event.preventDefault();
    if (diverse) return;
    dispatch(acceptInviteAsync({ token, password, passwordConfirm: conferma }))
      .then(esito => { if (!esito.error) setFatto(true); });
  };

  return <div className="mobile-auth"><div className="auth-content"><div className="wordmark"><BrandLogo /></div>
    <h1>{reimposta ? 'Nuova password.' : 'Benvenuto su Wozzap.'}</h1>
    {problema ? <p className="auth-error" role="alert">{problema}</p>
      : !invito ? <p>Controllo il link…</p>
      : <>
        <p>{reimposta ? 'Scegli una nuova password per ' : 'Stai creando l’account per '}<strong>{invito.email}</strong>.</p>
        <form className="auth-form" onSubmit={invia}>
          {isAuthenticated && user && user.email !== invito.email
            && <p className="auth-error">Sei dentro come {user.email}: proseguendo passerai all’account di {invito.email}.</p>}
          {error && <p className="auth-error" role="alert">{error}</p>}
          <div><label htmlFor="password">Password</label><input id="password" type="password" autoComplete="new-password" required minLength={8} value={password} onChange={e => setPassword(e.target.value)} placeholder="Almeno 8 caratteri" /></div>
          <div><label htmlFor="conferma">Ripeti la password</label><input id="conferma" type="password" autoComplete="new-password" required value={conferma} onChange={e => setConferma(e.target.value)} /></div>
          {diverse && <p className="auth-error">Le due password non coincidono.</p>}
          <button disabled={loading || diverse} type="submit">{loading ? 'Un momento…' : reimposta ? 'Salva la password ed entra' : 'Crea l’account ed entra'}</button>
        </form>
      </>}
  </div></div>;
}
